import type { Pagination } from '@pages/NeuralNetworkLogs/types';

export const initPagination: Pagination = {
  itemsPerPage: 20,
  page: 1,
  total: 0,
};

export const PF = 'NeuralNetworkLogs';
